export const ARIA_EXPANDED = "aria-expanded";
export const ARIA_HIDDEN = "aria-hidden";
export const TEXT_CONTENT = "textContent";
